export default __webpack_public_path__ + "static/media/themewagon.8930164b.png";